import ProductCatalogue from './ProductCatalogue';

/**
 * Retrieves Product Search data from Algolia - Hydraulink index
 * Loads Search results into main product content area
 * Search action triggered on typing if search term is 2 chars or longer
 */
 class ProductSearch {
  constructor() {
    this.searchform = document.querySelector('.product__search--form');
    this.productsearch = document.querySelector('.product__search--input');
    this.resultholder = document.querySelector('.product__tabcontent');
    this.clear = document.querySelector('.product__search--clear');
    this.pagecontent = document.querySelector('.product');

    this.events();
  }

  events() {
    //this.productsearch.addEventListener('keyup', this.performProductSearch.bind(this));
    if (this.resultholder !== null) {
      this.resultholder.addEventListener('click', this.searchResultsActions.bind(this));
    }
    if (this.clear !== null) {
      this.clear.addEventListener('click', e => {
        this.productsearch.value = '';
        this.reloadPage();
      });
    }

    console.log('searchform', this.searchform);
    if (this.searchform !== null) {
      this.searchform.addEventListener('submit', e => {
        e.preventDefault();
        this.performProductSearch(this.productsearch.value);
      });
    }
  }

  /**
   * Sends search request to @link Hydraulink\Controllers\SearchController
   * Populates search results element
   * @param string searchval
   * @return void 
   */
  performProductSearch(searchval) {

    console.log('searchval', searchval.length);
    if(searchval.length === 0) this.reloadPage();
    if (searchval.length < 2) return;
    const url = '/search/search_products';
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type':'application/json',
        // 'Content-Type':'text/html',
        'x-requested-with': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        start: 0,
        search: searchval
      })
    })
    .then(response => response.json())
    .then(data => {
      let reshtml = '<div class="product__tabcontent--content"><h2>Product Search Results</h2>';
      if(data.length === 0) {
        reshtml += '<p><strong>No results</strong></p>';
      } else {
        const $ol = data.map(res => this.resultTemplate(res)).join("\n");
        reshtml += `<ul class="product__search--results">${ $ol }</ul>`;
      }
      reshtml += "</div>";
      this.resultholder.innerHTML = reshtml;
      this.pagecontent.scrollIntoView({
        block: 'start',
        inline: 'nearest',
        behavior: 'smooth'
      });
    });
  }

  /**
   * @param {Object} data 
   * @return Populated result template
   */
  resultTemplate(data) {
    const bg = data.Image || '/public/static/img/image-not-available-alt.png';
    return `
      <li class="categories__products--product" data-route="${data.Link}">
        <div class="categories__products--product--image" style="background-image: url(${ bg });">
        </div>
        <div class="categories__products--product--title">
          <p>${data.Title}</p>
          <p>${data.Description}</p>
        </div>
      </li>    
    `;
  } 

  /**
   * Adds actions to search result box
   * Close action when the X is clicked
   * @param {Event} e 
   */
  searchResultsActions(e) {
    const product = e.target.closest('.product__search--results .categories__products--product');

    if(product !== null) {
      location.href = product.dataset.route;
    }
  }

  /**
   * For all tabs except the Product catalogue,
   * Simulates a click on the current tab to reload content.
   * For Product Catalogue it simulates a url change.
   * 
   * @return void;
   */
  reloadPage() {
    const currentTab = document.querySelector('.product__tabs li.selected');
    if(currentTab.dataset.tab == 'products') {
      const catalogue = new ProductCatalogue();
      document.dispatchEvent(catalogue.urlchange);
    } else {
      currentTab.click();
    }
  }
}

export default ProductSearch;